<h2 mat-dialog-title>Confirm</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-stroked-button color="primary" (click)="onCancel()">Cancel</button>

  <button mat-raised-button [color]="buttonValue === 'Delete' ? 'warn' : 'accent'" (click)="onConfirm()" class="delete-button">
    <mat-icon class="icon-left">
      {{ buttonValue === 'Delete' ? 'delete' : 'check_circle' }}
    </mat-icon>
    {{ buttonValue }}
  </button>
</mat-dialog-actions>
